// startup
// Load entry module
__webpack_require__("./assets/private/js/app.js");
// This entry module used 'exports' so it can't be inlined
__webpack_require__("./assets/private/css/app.scss");
